export default __webpack_public_path__ + "static/media/IMS_Logo.36bd9e4c.png";